import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { LocationSettingsDialogComponent } from '@/app/shared/components/location-settings-dialog/location-settings-dialog.component';
import { LocationPermissionService } from '@/app/shared/services/location-permission.service';

@Component({
  selector: 'fw-root',
  imports: [RouterOutlet, ToastModule, LocationSettingsDialogComponent],
  template: `
    <p-toast position="top-center" />
    <router-outlet />
    <fw-location-settings-dialog />
  `,
  styles: [`
    :host {
      display: block;
      height: 100%;
    }
  `],
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly locationPermissionService = inject(LocationPermissionService);

  title = 'FieldWork';

  ngOnInit(): void {
    this.locationPermissionService.startTracking();
  }

  ngOnDestroy(): void {
    this.locationPermissionService.stopTracking();
  }
}
